module.exports = __webpack_public_path__ + "static/media/cog-default.e4b413f7.svg";